import { CLASS_NAMES } from '../../factory/DataModel'

export default {
    namespaced: true,
    state: () => ({
        filterText: '',
        isShowFilter: false,
        cycleDetailsAreVisible: false,
        filterDays: [],
        [CLASS_NAMES.patient]: {
            filterByText: ''
        },
        [CLASS_NAMES.instrument]: {
            filterByText: ''
        },
        [CLASS_NAMES.treatment]: {
            filterByText: ''
        },
        [CLASS_NAMES.slide]: {
            filterByText: ''
        },
        [CLASS_NAMES.well]: {
            filterByText: ''
        }
    }),
    mutations: {
        filterText(state, text) {
            state.filterText = text
        },
        filterDays(state, days) {
            state.filterDays = days
        },
        changeFilterOption(state, showFilter) {
            state.isShowFilter = showFilter
            state.filterText = ''
        },
        setCycleDetailsVisibility(state, isVisible) {
            state.cycleDetailsAreVisible = isVisible
        }
    },
    actions: {}
}
